module.exports = __webpack_public_path__ + "img/enemy_123_002.60e28031.png";